var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.userData === undefined ? 'div' : 'b-card',{tag:"component"},[_c('user-edit-tab-account',{staticClass:"mt-2 pt-75",attrs:{"user-data":_vm.userData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }